import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getEnrollmentSelectionsReport = options =>
  call(websocketFetch, 'request_report', {
    type: 'enrollment_selections_report',
    request: options,
  });
